import client from "api/config";
import { convertNum } from "helper/convert-num";

////////// sms template /////////

const smsTemplateUrl = "/admin/sms_templates";
export const getAllSmsTemplatesRequest = (values) => {
  return client.get(smsTemplateUrl, values);
};

//////////// send sms ///////////////

const sendSmsUrl = "/admin/send_sms";
export const sendSmsRequest = (values) => client.post(sendSmsUrl, values);
